import { render, staticRenderFns } from "./ProductLinkFormList.vue?vue&type=template&id=5823b24b&"
import script from "./ProductLinkFormList.vue?vue&type=script&lang=js&"
export * from "./ProductLinkFormList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports